import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch Region List Data (with stateID)
export const fetchRegionList = createAsyncThunk(
  "region/fetchRegionList",
  async (stateID, { rejectWithValue }) => {
    try {
      let response;
      // console.log(stateID)
      if(stateID==undefined || stateID=='undefined'){
        response = await api.get(`/location/panel/RegionList`);
      }else{
         response = await api.get(`/location/panel/RegionList?stateID=${stateID}`);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add Region to the List
export const addRegionList = createAsyncThunk(
  "region/addRegionList",
  async (newRegionData, { rejectWithValue }) => {
    try {
      const response = await api.post("/location/panel/RegionList", newRegionData);
      alertSuccess(response.data.success);
      return newRegionData;
    } catch (error) {
      console.log(error.message);
      alertError(error.response.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update Region List Data
export const updateRegionList = createAsyncThunk(
  "region/updateRegionList",
  async (regionData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/location/panel/RegionList", regionData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Region List Slice
const regionSlice = createSlice({
  name: "region",
  initialState: {
    regionList: [],
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Region List
      .addCase(fetchRegionList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchRegionList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.regionList = action.payload;
      })
      .addCase(fetchRegionList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add Region
      .addCase(addRegionList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addRegionList.fulfilled, (state, action) => {
        state.status = "succeeded";
        // state.regionList.push(action.payload);
      })
      .addCase(addRegionList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update Region List
      .addCase(updateRegionList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateRegionList.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(updateRegionList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload; 
      });
  },
});

export const { clearError } = regionSlice.actions;

export default regionSlice.reducer;
